var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.667,
    height: 74.857,
    viewBox: "0 0 70 70.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0h30L0 70.179v-30z",
    fill: "#0058ad",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-45 -701.554 -290.593)",
    y: 455.01,
    x: -441.144,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve",
    fontWeight: 400,
    fontSize: 48.802,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      InkscapeFontSpecification: "'sans-serif Bold'"
    },
    y: 455.01,
    x: -441.144,
    fontWeight: 700,
    fontSize: 12.2,
    fill: "#fff"
  }, "\xC0 LA UNE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.ce6a38878690f6bfa2bedb27bf6bda31.svg";
export { ForwardRef as ReactComponent };